exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loader[data-v-48d6ffba] {\n\tposition: fixed;\n\tz-index: 999;\n\ttop: 0;\n\tleft: 0;\n\theight: 100vh;\n\twidth: 100vw;\n\tbackground-color: rgba(0,0,0,0.8);\n\tdisplay: flex;\n\ttext-align: center;\n}\n.loader h3[data-v-48d6ffba] {\n\twidth: 100%;\n\theight: 60px;\n\tmargin: 0 auto;\n\talign-self: center;\n\tjustify-self: center;\n\ttext-align: center;\n\tcolor: #fff;\n\tfont-size: 30px;\n}\n.loader h3 .label[data-v-48d6ffba] {\n\tvertical-align: text-bottom;\n\tline-height: 30px;\n}\n\n", ""]);

// exports
